import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { getErrorMessage } from '~libs/axiosWrapper';

import { Button, ContainerHeader, ErrorResponse, Spinner } from '~components';
import { faArrowRotateBack } from '~components/icon';

import { useRollbackInviteQuery } from '~support-at-home/actions/statements';

import StatementsRollbackWizard from './Wizard';

const CLAIMS_PATH = '/support-at-home/claims';

// TAV-3491: the only way into the statement rollback wizard. TurnPoint Support sends a single-use link
// (support-at-home/statements-rollback/:token). Closing the wizard leaves the page, and only the same
// link (until it is used or expires) or a new one opens it again. Nothing else in the app links here.
const InvitePage: React.FC = () => {
  const { token = '' } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const { data: invite, error, isFetching } = useRollbackInviteQuery(token, { skip: !token });

  const leave = () => navigate(CLAIMS_PATH, { replace: true });
  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    if (!open) leave();
  };

  return (
    <div className="p-2">
      <ContainerHeader icon={faArrowRotateBack} iconSize="1x" className="info" dataCy="statements-rollback-header">
        <span>Support at Home Statement Rollback</span>
      </ContainerHeader>
      <Spinner loading={isFetching} />
      {!isFetching && (error || !token) && (
        <div className="p-3">
          <ErrorResponse
            message={token ? getErrorMessage(error) : 'This rollback link is not valid.'}
            dataCy="statements-rollback-link-error"
          />
          {/* Same space below the message as above it (header gap + p-3 + the message's own margin). */}
          <div className="mt-4 pt-2">
            <Button color="info" onClick={leave} dataCy="statements-rollback-link-back">
              Back to Claims
            </Button>
          </div>
        </div>
      )}
      {!isFetching && invite && (
        <StatementsRollbackWizard
          token={token}
          invite={invite}
          isOpen={isOpen}
          setIsOpen={handleOpenChange}
          onRolledBack={leave}
        />
      )}
    </div>
  );
};

export default InvitePage;
